import { render, staticRenderFns } from "./Reports2.vue?vue&type=template&id=2a7d34c3"
import script from "./Reports2.vue?vue&type=script&lang=js"
export * from "./Reports2.vue?vue&type=script&lang=js"
import style0 from "./Reports2.vue?vue&type=style&index=0&id=2a7d34c3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__cache-loader@4.1.0_web_d5832da0dceb3d3da3dfe51a80da8c07/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports